module.exports = __webpack_public_path__ + "img/ec.ec33ce562.svg";